export default __webpack_public_path__ + "assets/accept-or-reject-order.e116876e.svg";